import { UploadOutlined } from "@ant-design/icons";
import { Button, Form, Upload } from "antd";
import React, { useState } from "react";
import { is_valid_file_upload } from "../../helpers/utils";

export const FileUploadUi = ({ name, filelist, ...props }) => {
  const form = Form.useFormInstance();
  const { setFieldValue, validateFields } = form;
  const [fileList, setFileList] = useState(filelist || []);
  const propsUpload = {
    onRemove: (file) => {
      const index = fileList.indexOf(file);
      const newFileList = fileList.slice();
      newFileList.splice(index, 1);
      setFileList(newFileList);
      setFieldValue(name, newFileList);
    },
    beforeUpload: (file) => {
      return false;
    },
    onChange: ({ file, fileList: newFileList }) => {
      if (file?.status !== "removed") {
        const is_valida = is_valid_file_upload(file, props?.accept);
        if (is_valida) {
          setFileList(newFileList);
          setFieldValue(name, newFileList);
          validateFields([name]);
        }
      }
    },
    fileList,
  };
  return (
    <Upload {...props} {...propsUpload}>
      <Button icon={<UploadOutlined />}>Subir archivo</Button>
    </Upload>
  );
};
